import React from 'react';
import Slider from 'react-slick';
import { images } from '../../../assets/images'


/* function SampleNextArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-right"></i>
        </div>
    );
}

function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return (
        <div
            className={className}
            onClick={onClick}
        >
            <i className="far fa-angle-left"></i>
        </div>
    );
} */

function TestimonialSlider() {
    var settings = {
        autoplay: true,
        dots: true,
        infinite: true,
        speed: 2500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        adaptiveHeight: true,
        /* nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow /> */
    };
    return (
        <div className="testimonial_slider">
            <Slider {...settings}>
                <div className="testimonial_item text-center">
                    <div className="testimonial_content">
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maxime at, incidunt voluptatum rem repudiandae praesentium laboriosam? Quisquam nostrum vel facilis molestiae, laborum impedit repudiandae eaque ab incidunt, dignissimos deserunt illum labore excepturi fuga repellendus fugit ea minima quam quae possimus.
                        </p>
                    </div>
                    <div className="testimonial_info">
                        <div className="testi_img">
                            <img src={images.user1} alt="..." className="img-fluid d-block mx-auto" />
                        </div>
                        <h4>John Doe</h4>
                        <h5>Client From USA</h5>
                    </div>
                </div>
                <div className="testimonial_item text-center">
                    <div className="testimonial_content">
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maxime at, incidunt voluptatum rem repudiandae praesentium laboriosam? Quisquam nostrum vel facilis molestiae, laborum impedit repudiandae eaque ab incidunt, dignissimos deserunt illum labore excepturi fuga repellendus fugit ea minima quam quae possimus.
                        </p>
                    </div>
                    <div className="testimonial_info">
                        <div className="testi_img">
                            <img src={images.user1} alt="..." className="img-fluid d-block mx-auto" />
                        </div>
                        <h4>John Doe</h4>
                        <h5>Client From USA</h5>
                    </div>
                </div>
                <div className="testimonial_item text-center">
                    <div className="testimonial_content">
                        <p>
                            Lorem ipsum dolor sit, amet consectetur adipisicing elit. Maxime at, incidunt voluptatum rem repudiandae praesentium laboriosam? Quisquam nostrum vel facilis molestiae, laborum impedit repudiandae eaque ab incidunt, dignissimos deserunt illum labore excepturi fuga repellendus fugit ea minima quam quae possimus.
                        </p>
                    </div>
                    <div className="testimonial_info">
                        <div className="testi_img">
                            <img src={images.user1} alt="..." className="img-fluid d-block mx-auto" />
                        </div>
                        <h4>John Doe</h4>
                        <h5>Client From USA</h5>
                    </div>
                </div>
            </Slider>
        </div>
    );
}

export { TestimonialSlider };
